import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import StartNumbersTable from './startNumbersTable/StartNumbersTable';
import CustomToast from '../../../components/CustomToast';
import { useContext, useState } from 'react';
import StartNumbersContext from '../../../contexts/StartNumbersContext';
import {
  updateCompetition,
  assignRacingNumbers
} from '../../../api/Competitions'

const StartNumbersModal = ({ className, onHide, competition, ...props }) => {
  const [toastData, setToastData] = useState({
    type: '',
    body: '',
    title: '',
    show: false,
  });
  const { addStartNumberGroup, isFormValid, startNumberGroups } = useContext(StartNumbersContext);

  const saveNewValues = async (closeModalOnSuccess = true) => {
    const mappedData = {
      "intervals": []
    };

    startNumberGroups.forEach(entry => {
      const raceClasses = entry.raceClasses.map(rc => rc.Id);
      const startingRacingNumber = entry.startNumber;

      const interval = {
        "RaceClasses": raceClasses,
        "StartingRacingNumber": startingRacingNumber
      };

      mappedData.intervals.push(interval);
    });
    const values = { ...competition, racingNumberClassIntervals: mappedData }
    const success = await updateCompetition(values)
    if (closeModalOnSuccess && success) {
      onHide()
      setToastData({ type: 'success', body: 'Index av startnummer har uppdaterats', title: 'Dina ändringar är sparade', show: true })
    }
    if (!success) {
      setToastData({ type: 'danger', body: 'Något gick fel', title: 'Index av startnummer kunde inte uppdateras', show: true })
    }
  };

  const saveNewValuesAndAssignStartNumbers = async () => {
    await saveNewValues(false)
    const success = await assignRacingNumbers(competition.competitionId)
    if (success) {
      onHide()
      setToastData({ type: 'success', body: 'Startnummer har tilldelats', title: 'Dina ändringar är sparade', show: true })
    } else {
      setToastData({ type: 'danger', body: 'Något gick fel', title: 'Tilldelningen av startnummer kunde inte sparas', show: true })
    }
  };

  return (
    <>
      <Modal
        centered
        aria-labelledby='contained-modal-title-vcenter'
        className={`p-3 modal-xl ${className}`}
        onHide={onHide}
        {...props}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Ange vilket startnummer som är det lägsta i respektive klass
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className='d-flex flex-column align-items-end'>
          <StartNumbersTable />
          <Button
            variant='outline-primary'
            className='d-flex gap-2 align-items-center'
            onClick={addStartNumberGroup}
          >
            Lägg till startnummer
            <span
              className='material-symbols-outlined'
              style={{ fontSize: '20px' }}
            >
              add
            </span>
          </Button>
          {!isFormValid && (<p className='mt-4'>Alla startnummer måste vara större än 0 och avståndet till nästa klass kan inte vara negativt</p>)}
        </Modal.Body>

        <Modal.Footer className='d-flex justify-content-between'>
          <Button onClick={onHide} variant='outline-secondary'>
            Avbryt
          </Button>

          <div className='d-flex flex-column flex-md-row gap-2 col-md-auto col-12'>
            <Button disabled={!isFormValid} onClick={saveNewValues}>Spara startnummer</Button>
            <Button disabled={!isFormValid} onClick={saveNewValuesAndAssignStartNumbers}>Spara startnummer och tilldela</Button>
          </div>
        </Modal.Footer>
      </Modal>
      <CustomToast
        type={toastData.type}
        body={toastData.body}
        title={toastData.title}
        show={toastData.show}
        onClose={() => setToastData({ type: '', body: '', title: '', show: false })}
      />
    </>
  );
};

export default StartNumbersModal;
